// P3 — "How to read this report" intro card. Verbatim from PaidReport.jsx (W2c).
// Pure presentational; no props.
export default function ReportHowToRead() {
  return (
    <div
      className="sf-card"
      data-testid="paid-report-how-to-read"
      style={{ marginBottom: 32, borderColor: "var(--sf-gold-dim)" }}
    >
      <div className="sf-eyebrow" style={{ marginBottom: 12 }}>How to read this report</div>
      <p style={{ color: "var(--sf-offwhite)", fontSize: 14, lineHeight: 1.7, margin: 0 }}>
        This audit is a diagnostic, not a marketing document. Section 1 is
        the headline. Sections 2 through 10 work through each system: what
        we found, why it matters, what it is costing, and what to do.
        Sections 11 and 12 prioritize the fixes and model the ROI. Section
        13 is the 90-day action plan — start there if you only have ten
        minutes.
      </p>
    </div>
  );
}
